import { render, staticRenderFns } from "./ForemanProjectDetail.vue?vue&type=template&id=00d1f4dc&scoped=true"
import script from "./ForemanProjectDetail.vue?vue&type=script&lang=js"
export * from "./ForemanProjectDetail.vue?vue&type=script&lang=js"
import style0 from "./ForemanProjectDetail.vue?vue&type=style&index=0&id=00d1f4dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d1f4dc",
  null
  
)

export default component.exports